import { useState } from "react";
import {
  Group,
  Burger,
  Box,
  Drawer,
  Divider,
  Button,
  Collapse,
  UnstyledButton,
  ThemeIcon,
  useMantineTheme,
  Text,
  Center,
  ScrollArea,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
// import { MantineLogo } from '@mantinex/mantine-logo';
import classes from "../styles//Header.module.css";
import Image from "next/image";
import { IconArrowLeft, IconChevronDown, IconScissors } from "@tabler/icons";
import useTranslation from "@/hooks/useTranslation";
import Link from "next/link";

import { HeaderMegaMenu } from "./HeaderMegaMenu";
import { CosmeticsIcon } from "./icons/CosmeticsIcon";
export function Header() {
  const { t } = useTranslation();
  const links = [
    { label: t("Header")[0].label, link: "/" },
    { label: "אודות", link: "/about" },
    { label: "מרכז מידע", link: "/magazine" },
    { label: "מחירון", link: "/pricing" },
    { label: t("Header")[2].label, link: "/contact" },
  ];

  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
    useDisclosure(false);

  const [linksOpened, { toggle: toggleLinks }] = useDisclosure(false);

  const mockdata = [
    {
      icon: CosmeticsIcon,
      link: "/queue-management-beauticians",
      title: "קוסמטיקאיות",
      description: "גמישות מירבית להגדיר את המערכת לצרכים שלך",
    },
    {
      icon: IconScissors,

      link: "/managing-queues-hair-salons",
      title: "ניהול מספרות",
      description: "כל הכלים שמתאימים למספרות במקום אחד",
    },
    // {
    //   icon: IconCode,
    //   link: "/",
    //   title: "Free for everyone",
    //   description: "The fluid of Smeargle’s tail secretions changes",
    // },
    // {
    //   icon: IconCode,
    //   link: "/",
    //   title: "Documentation",
    //   description: "Yanma is capable of seeing 360 degrees without",
    // },
  ];
  const theme = useMantineTheme();

  const subLinks = mockdata.map((item) => (
    <UnstyledButton
      component="a"
      href={item.link}
      className={classes.subLink}
      key={item.title}
    >
      <Group wrap="nowrap" align="flex-start">
        <ThemeIcon size={34} variant="default" radius="md">
          <item.icon size={22} color={theme.colors.blue[6]} />
        </ThemeIcon>
        <div>
          <Text size="sm" fw={500}>
            {item.title}
          </Text>
          <Text size="xs" c="dimmed">
            {item.description}
          </Text>
        </div>
      </Group>
    </UnstyledButton>
  ));
  const [active, setActive] = useState(links[0].link);
  const items = links.map((link, i) => {
    return (
      <Link
        key={i}
        href={link.link}
        className={classes.link}
        data-active={active === link.link || undefined}
        onClick={() => {
          setActive(link.link);
          closeDrawer();
        }}
      >
        <div>{link.label}</div>
      </Link>
    );
  });

  return (
    <Box>
      <header className={classes.header}>
        <Group className={classes.inner}>
          <div>
            <a href="/">
              <Image
                src="/logo-no-background.svg"
                width={200}
                height={100}
                alt="לוגו QuickTor - המילה QuickTor בצבע כחול עם אייקון חץ מהיר, המסמל תור מהיר וזריז"
              />
            </a>
          </div>
          <Group gap={5} visibleFrom="xs">
            {items}
            <HeaderMegaMenu classes={classes} mockdata={mockdata} />
          </Group>

          <Burger
            opened={drawerOpened}
            onClick={toggleDrawer}
            hiddenFrom="xs"
            size="sm"
          />
          <div className={classes.blockButton}>
            <Button
              rightSection={<IconArrowLeft />}
              variant={"filled"}
              component={"a"}
              href={
                "https://app.quicktor.co.il/MainPageToConnect/CreateBusinessAccount"
              }
              radius={20}
              fw={700}
              size={"md"}
            >
              להתחיל עכשיו
            </Button>
          </div>
        </Group>
      </header>

      <Drawer
        opened={drawerOpened}
        onClose={closeDrawer}
        size="100%"
        padding="md"
        hiddenFrom="sm"
        zIndex={1000000}
      >
        <ScrollArea h="calc(100vh - 80px" mx="-md">
          <Divider my="sm" />

          {items}
          <UnstyledButton className={classes.link} onClick={toggleLinks}>
            <Center inline>
              <Box component="span" mr={5}>
                פתרונות לפי תחום
              </Box>
              <IconChevronDown size={16} color={theme.colors.blue[6]} />
            </Center>
          </UnstyledButton>
          <Collapse in={linksOpened}>{subLinks}</Collapse>
          <Divider my="sm" />

          <Group justify="center">
            <Button
              rightSection={<IconArrowLeft />}
              variant={"filled"}
              radius={20}
              fw={700}
              size={"md"}
              component={"a"}
              href={
                "https://app.quicktor.co.il/MainPageToConnect/CreateBusinessAccount"
              }
            >
              להתחיל עכשיו
            </Button>{" "}
          </Group>
        </ScrollArea>
      </Drawer>
    </Box>
  );
}
